import { intl } from '@fullstory/intl';
import { Classification } from '@fullstory/proto/fs/services/search-settings';
import { useFlags } from '@fullstory/react-hooks';
import {
  ClassificationRulesRequestActions,
  classificationRulesSelectors,
  fullstorySelectors,
} from '@fullstory/redux';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Formal names for the classification options.
const classificationOptions = [
  {
    key: 'pii',
    value: Classification.CLASSIFICATION_PII,
    label: intl.formatMessage({
      defaultMessage: 'Personally Identifiable Information (PII)',
      id: 'PNvCCz',
    }),
  },
  {
    key: 'financial',
    value: Classification.CLASSIFICATION_FINANCIAL,
    label: intl.formatMessage({ defaultMessage: 'Financial Data', id: 'lCNiyF' }),
  },
  {
    key: 'restricted',
    value: Classification.CLASSIFICATION_RESTRICTED,
    label: intl.formatMessage({ defaultMessage: 'Restricted', id: 'dyyjkY' }),
  },
  {
    key: 'unrestricted',
    value: Classification.CLASSIFICATION_UNRESTRICTED,
    label: intl.formatMessage({ defaultMessage: 'Unrestricted', id: 'GbcJ90' }),
  },
];

export const useClassificationRulesForElement = (elementId?: string) => {
  const allRules = useClassificationRules();

  const loadingClassification = useSelector(
    classificationRulesSelectors.getClassificationRulesLoading,
  );

  const existingClassificationRecord = elementId ? allRules.get(elementId) || null : null;

  const selectedClassification =
    existingClassificationRecord?.classificationRule?.classification || null;

  return {
    classificationOptions,
    selectedClassification,
    loadingClassification,
    existingClassificationRecord,
  };
};

export const useClassificationRules = () => {
  const dispatch = useDispatch();
  const orgId = useSelector(fullstorySelectors.getOrgId);
  const flags = useFlags();
  const classificationRulesEnabled = flags.featureFlags().AppClassificationRules;

  useEffect(() => {
    if (orgId && classificationRulesEnabled) {
      dispatch(ClassificationRulesRequestActions.getAllClassificationRules(orgId));
    }
  }, [dispatch, orgId, classificationRulesEnabled]);

  return useSelector(classificationRulesSelectors.getClassificationRuleRecordsByElementId);
};
